import { Badge } from 'antd';
import React, { useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router';
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import MultiSelectEntity from '../RefineSearch/MultiSelectEntity'
import FilterWrapper from './FilterWrapper';
import { UserContext } from '../../Contexts/UserContext';
import useModule from '../../hooks/useModule';
import Popup from '../Common/Popup';

/**
 * The `IndustryFilter` function is a React component that renders a filter for selecting industries,
 * with options that can be expanded or collapsed.
 * @returns a JSX element.
 */
function IndustryFilter({ IndustriesOptions, setIndustriesOptions, customPathname, label="Industry", isPopupOpen, setIsPopupOpen }) {

    const { Industries, refineSearchFilters, accessControl } = useContext(PeFilterContext);
    const { isPE, isVC, isMA } = useModule();
    const [internalPopupOpen, setInternalPopupOpen] = useState(false);
    const popupOpen = isPopupOpen !== undefined ? isPopupOpen : internalPopupOpen;
    const setPopupOpen = setIsPopupOpen !== undefined ? setIsPopupOpen : setInternalPopupOpen;

    // useEffect(() => { 
    //     setIndustriesOptions(Industries)
    // }, [Industries])

    useEffect(() => {
        const industryIds = refineSearchFilters[customPathname]?.acquirer_industry?.map(value => value.id) ?? [];
        setIndustriesOptions(Industries?.map(industry => ({ ...industry, isChecked: industryIds.includes(industry.id) })))
    }, [Industries, customPathname, refineSearchFilters, setIndustriesOptions])

    const enabledIds = accessControl ? (isPE || isVC ? accessControl?.peindustries?.id : isMA ? accessControl?.maindustries?.id : accessControl?.cfsindustries?.id) : [];
    
    const disabledInd = enabledIds?.length > 0 ? IndustriesOptions?.filter(op => !enabledIds?.includes(op.id)) : [];


    const handleIndustryChange = (e) => {
        const { name, checked, id, filteredIds } = e.target;
        let currentIndustry = [];
    
        if (name === "allSelect") {
            currentIndustry = IndustriesOptions.map((industry) =>
                ({ ...industry, isChecked: checked })
            );
        } else if (name === "filteredSelect" && filteredIds) {
            currentIndustry = IndustriesOptions.map((industry) => {
                if (filteredIds.includes(industry.id)) {
                    return { ...industry, isChecked: checked };
                }
                return industry;
            });
        } else {
            currentIndustry = IndustriesOptions.map((industry) =>
                industry.id === parseInt(id) ? { ...industry, isChecked: checked } : industry
            );
        }
    
        setIndustriesOptions(currentIndustry);
    };
    

    const selectedIndustryLength = IndustriesOptions?.filter(option => option.isChecked)?.length ?? 0

    return (
        <div className="relative w-full md:inline-block">
            <button
                type="button"
                className="h-10 rounded-md px-4 py-1 text-gray-500 hover:bg-gray-100  text-sm shadow-md border border-gray-300 text-left flex items-center justify-between w-full md:w-[90%]"
                onClick={() => setPopupOpen(!popupOpen)}
            >
                <span className="truncate pr-2">{label} <span className="opacity-60 ml-2 text-xs text-ellipsis">e.g. {Industries.slice(11,13).map(item => item.name).join(', ')}</span></span>
                <div className="flex items-center gap-2 flex-shrink-0">
                    {selectedIndustryLength > 0 && (
                        <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
                            {selectedIndustryLength}
                        </span>
                    )}
                    <span className={`transition-transform duration-200 text-xl font-semibold ${popupOpen ? 'rotate-[270deg]' : 'rotate-90'}`}>
                        ›
                    </span>
                </div>
            </button>

            {popupOpen && (
                <Popup onClose={() => setPopupOpen(false)} label={label}>
                    <div className="p-4">
                        <MultiSelectEntity
                            handleEntityChange={handleIndustryChange}
                            primaryEntity={IndustriesOptions}
                            disabled={disabledInd}
                        />
                    </div>
                </Popup>
            )}
        </div>
    )
}

export default IndustryFilter